<!--
 * @Description  :
 * @Author       : git config user.sname
 * @Date         : 2026-01-08 10:27:48
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-01-17 16:13:47
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\commodity-management\product-list\components\view.vue
-->

<template>
	<div v-if="dialogObj.visible" class="product-list-dialog">
		<el-dialog
			:visible.sync="dialogObj.visible"
			:title="dialogObj.title"
			:width="dialogObj.width"
			class="primary-dialog"
			:close-on-click-modal="false"
			@close="handleClosed"
			top="3vh"
			center
		>
			<div v-if="dialogObj.visible" class="form-content">
				<el-form class="tableForm" size="medium" ref="formObjRfe" label-width="110px" :model="formObj" :show-message="false" disabled>
					<Panel :expand="true" title="请选择商品集并填写商品名称">
						<el-form-item label="商品集" prop="proValue" :rules="requiredRule">
							<el-select v-model="formObj.proValue" size="small">
								<el-option v-for="item in commodityDict.spj" :key="'商品名称' + item.value" :label="item.sname" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="商品名称" prop="sname" :rules="requiredRule">
							<el-input v-model="formObj.sname" :maxlength="50" placeholder="请输入"></el-input>
						</el-form-item>
					</Panel>
					<Panel :expand="true" title="#1 基本信息">
						<el-form-item label="商品属性" prop="proAttr" :rules="requiredRule">
							<el-select v-model="formObj.proAttr" size="small" @change="changeSelect('1', formObj.proAttr)">
								<el-option v-for="item in proAttrOptions" :key="'商品属性' + item.value" :label="item.sname" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="商品类型" prop="proType" :rules="requiredRule">
							<el-select v-model="formObj.proType" size="small" @change="changeSelect('2', formObj.proType)">
								<el-option v-for="item in proTypeOptions" :key="'商品子类' + item.value" :label="item.sname" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="商品大类" prop="proSup" :rules="requiredRule">
							<el-select v-model="formObj.proSup" size="small" @change="changeSelect('3', formObj.proSup)">
								<el-option v-for="item in proSupOptions" :key="'商品大类' + item.value" :label="item.sname" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="商品子类" prop="proSub" :rules="requiredRule">
							<el-select v-model="formObj.proSub" size="small">
								<el-option v-for="item in proSubOptions" :key="'商品子类' + item.value" :label="item.sname" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="归属主体" prop="applySub" :rules="requiredRule">
							<el-select v-model="formObj.applySub" size="small">
								<el-option v-for="item in gszt" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="商品简介" prop="proIntro" :rules="requiredRule">
							<el-input
								placeholder="请输入"
								v-model="formObj.proIntro"
								type="textarea"
								:autosize="{ minRows: 3 }"
								:maxlength="100"
								show-word-limit
							></el-input>
						</el-form-item>
						<el-form-item label="是否组合商品" prop="isJoint" :rules="requiredRule">
							<el-select v-model="formObj.isJoint" size="small">
								<el-option :value="1" label="是"></el-option>
								<el-option :value="0" label="否"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="商品识别码" prop="proId" :rules="requiredRule" class="append-btn">
							<el-input v-model="formObj.proId" :maxlength="50" placeholder="请输入"></el-input>
							<span class="tips-color">注：商品识别码主要由商品英文缩写加数字组成，具体请查阅商品分类明细表</span>
						</el-form-item>
					</Panel>
					<Panel :expand="true" title="#2 收费及分账信息">
						<el-form-item label="收费方式" prop="feeType" :rules="requiredRule">
							<el-select v-model="formObj.feeType" size="small" @change="changeSelect('4', '')">
								<el-option :value="'0'" label="周期收费"></el-option>
								<el-option :value="'1'" label="按次收费"></el-option>
							</el-select>
						</el-form-item>
						<!--周期收费-->
						<template v-if="formObj.feeType == '0'">
							<el-form-item label="收费规则" prop="cycleType" :rules="requiredRule">
								<el-select v-model="formObj.cycleType" size="small" @change="changeSelect('5', formObj.cycleType)">
									<el-option :value="0" label="按年收费"></el-option>
									<el-option :value="1" label="按月收费"></el-option>
									<el-option :value="2" label="按天收费"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item
								label="可订购周期"
								prop="cycleValue"
								:rules="requiredRule"
								v-if="formObj.cycleType == '0' || formObj.cycleType == '1' || formObj.cycleType == '2'"
							>
								<el-select v-model="formObj.cycleValue" size="small" @change="changeSelect('7', formObj.cycleValue)">
									<el-option v-for="item in options" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="商品价格" prop="fixPrice" :rules="requiredRule">
								<el-input placeholder="请输入" v-model="formObj.fixPrice" @input="priceMoneyCheck($event, 'formObj', 'fixPrice')">
									<template slot="append">元</template>
								</el-input>
							</el-form-item>
						</template>

						<!--按次收费-->
						<template v-if="formObj.feeType == '1'">
							<el-form-item label="收费规则" prop="cycleType" :rules="requiredRule">
								<el-select v-model="formObj.cycleType" size="small" @change="changeSelect('6', '')">
									<el-option :value="1" label="阶梯价"></el-option>
									<el-option :value="0" label="固定价"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="固定单价" prop="fixPrice" :rules="requiredRule" v-if="formObj.cycleType == '0'">
								<el-input v-model="formObj.fixPrice" @input="priceMoneyCheck($event, 'formObj', 'fixPrice')" placeholder="请输入"
									><template slot="append">元</template></el-input
								>
							</el-form-item>
							<el-form-item label="阶梯价格" prop="usePrice" :rules="requiredRule" v-if="formObj.cycleType == '1'">
								<div class="flex mb10" v-for="(item, index) in formObj.stairPriceList" :key="'阶梯价格' + index">
									<span>使用&gt;</span><el-input v-model="item.useTime" class="w100"></el-input><span class="ml10">次，价格</span
									><el-input
										v-model="item.usePrice"
										class="w200"
										@input="priceMoneyCheck($event, 'formObj', 'stairPriceList', 'usePrice', index)"
										><template slot="append">元</template></el-input
									>
								</div>
							</el-form-item>
						</template>
						<el-form-item label="是否分账" prop="isDevide" :rules="requiredRule">
							<el-select v-model="formObj.isDevide" size="small">
								<el-option :value="1" label="是"></el-option>
								<el-option :value="0" label="否"></el-option>
							</el-select>
						</el-form-item>

						<!--分账字段信息-->
						<template v-if="formObj.isDevide == '1'">
							<el-form-item label="分账方式" prop="devideType" :rules="requiredRule">
								<el-select v-model="formObj.devideType" size="small">
									<el-option :value="1" label="按比例分账"></el-option>
									<el-option :value="0" label="按金额分账"></el-option>
								</el-select>
							</el-form-item>
							<!--金额分账-->
							<template v-if="formObj.devideType == '0'">
								<el-form-item label="平台分账金额" prop="platRatio" :rules="requiredRule">
									<el-input v-model="formObj.platRatio" @input="priceMoneyCheck($event, 'formObj', 'platRatio')"
										><template slot="append">元</template></el-input
									>
								</el-form-item>
								<el-form-item label="商家分账金额" prop="merRatio" :rules="requiredRule">
									<el-input v-model="formObj.merRatio" @input="priceMoneyCheck($event, 'formObj', 'merRatio')"
										><template slot="append">元</template></el-input
									>
								</el-form-item>
							</template>
							<!--比例分账-->
							<template v-if="formObj.devideType == '1'">
								<el-form-item label="平台分账比例" prop="platRatio" :rules="requiredRule">
									<el-input v-model="formObj.platRatio" @input="priceMoneyCheck($event, 'formObj', 'platRatio')"
										><template slot="append">%</template></el-input
									>
								</el-form-item>
								<el-form-item label="商家分账比例" prop="merRatio" :rules="requiredRule">
									<el-input v-model="formObj.merRatio" @input="priceMoneyCheck($event, 'formObj', 'merRatio')"
										><template slot="append">%</template></el-input
									>
								</el-form-item>
							</template>

							<el-form-item label="分账主体" prop="subTenant" :rules="requiredRule">
								<el-input v-model="formObj.subTenant" placeholder="请输入" :maxlength="50"></el-input>
							</el-form-item>
							<el-form-item label="收款公司" prop="collectTenant">
								<el-input v-model="formObj.collectTenant" placeholder="请输入" :maxlength="50"></el-input>
							</el-form-item>
							<el-form-item label="收款账户名" prop="collectAccount">
								<el-input v-model="formObj.collectAccount" placeholder="请输入" :maxlength="50"></el-input>
							</el-form-item>
							<el-form-item label="收款账号" prop="collectNo">
								<el-input v-model="formObj.collectNo" placeholder="请输入" :maxlength="50"></el-input>
							</el-form-item>
							<el-form-item label="收款开户行" prop="collectBank">
								<el-input v-model="formObj.collectBank" placeholder="请输入" :maxlength="50"></el-input>
							</el-form-item>
							<el-form-item label="收款联系人" prop="collectLink">
								<el-input v-model="formObj.collectLink" placeholder="请输入" :maxlength="20"></el-input>
							</el-form-item>
							<el-form-item label="税号" prop="taxNo">
								<el-input v-model="formObj.taxNo" placeholder="请输入" :maxlength="50"></el-input>
							</el-form-item>
						</template>
					</Panel>
					<Panel :expand="true" title="#3 组合商品信息" v-if="formObj.isJoint && formObj.isJoint == '1'">
						<el-form-item label="赠送商品" prop="goods">
							<el-select v-model="formObj.goods" multiple size="small" @change="changeGoods">
								<el-option v-for="item in goodOptions" :key="item.id" :label="item.sname" :value="item.id"> </el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="赠送商品数" prop="giveGoodList" v-if="formObj.goods.length != 0">
							<div v-for="(item, index) in formObj.giveGoodList" :key="'赠送商品数' + index" class="goods-list">
								<span class="list-title">{{ item.giveName }}</span>
								<el-input
									placeholder="请输入"
									v-model="item.giveNum"
									@input="moneyCheck($event, 'formObj', 'giveGoodList', 'giveNum', index)"
									:maxlength="10"
								>
									<template slot="append">个</template>
								</el-input>
							</div>
						</el-form-item>
					</Panel>
					<Panel :expand="true" :title="formObj.isJoint && formObj.isJoint == '1' ? '#4 商品图片信息' : '#3 商品图片信息'">
						<div :class="[{ h230: isEdit1 || isEdit2 || isEdit3 || isEdit4 }, 'flex', 'justify-content']">
							<div class="goods-file">
								<new-upload
									class="mr15"
									ref="good_pic_main"
									:aid="formObj.id"
									width="190"
									listType="picture-card"
									:lazyTime="lazyTime"
									:tableName="'tem_good_list'"
									assortment="good_pic_main"
									:acceptType="goodsAccept"
									:maxNum="1"
									:title="'商品主图'"
									@getFileSuccess="getFileSuccess($event, 'picMainFile')"
									@saveSuccess="saveSuccess"
									@onDelFile="onDelFile"
									:isDisabled="isDiabled"
								></new-upload>
								<div class="mt10" v-if="picMainFile.length != 0">
									<div v-if="!isEdit1" style="text-align: center">
										<span class="ellipsis">{{ picMainFile[0].fileName }}</span>
										<svg-icon
											v-if="!isDiabled"
											icon-class="form-edit"
											style="color:#409EFF;vertical-align: 2px "
											class="ml5"
											@click="openEdit('PicMainFileName', picMainFile[0].fileName, 'isEdit1')"
										></svg-icon>
									</div>
									<div v-else>
										<el-input v-model="PicMainFileName" size="small" :maxlength="20"></el-input>
										<div class="flex">
											<el-button size="mini" class="mt10" @click="clearEdit('PicMainFileName', 'isEdit1')">取消</el-button>
											<el-button
												size="mini"
												type="primary"
												class="mt10"
												@click="saveFileName('picMainFile', PicMainFileName, 'isEdit1')"
												>确定</el-button
											>
										</div>
									</div>
								</div>
							</div>
							<div class="goods-file">
								<new-upload
									class="mr15"
									ref="spUpload"
									:aid="formObj.id"
									width="190"
									listType="picture-card"
									:lazyTime="lazyTime"
									:tableName="'tem_good_list'"
									assortment="good_pic_add_one"
									:acceptType="goodsAccept"
									:maxNum="1"
									:title="'商品附图'"
									@getFileSuccess="getFileSuccess($event, 'figureFile')"
									@saveSuccess="saveSuccess"
									@onDelFile="onDelFile"
									:isDisabled="isDiabled"
								></new-upload>
								<div class="mt10" v-if="figureFile.length != 0">
									<div v-if="!isEdit2" style="text-align: center">
										<span class="ellipsis">{{ figureFile[0].fileName }}</span>
										<svg-icon
											v-if="!isDiabled"
											icon-class="form-edit"
											style="color:#409EFF;vertical-align: 2px "
											class="ml5"
											@click="openEdit('figureFileName1', figureFile[0].fileName, 'isEdit2')"
										></svg-icon>
									</div>
									<div v-else>
										<el-input v-model="figureFileName1" size="small" :maxlength="20"></el-input>
										<div class="flex">
											<el-button size="mini" class="mt10" @click="clearEdit('figureFileName1', 'isEdit2')">取消</el-button>
											<el-button
												size="mini"
												type="primary"
												class="mt10"
												@click="saveFileName('figureFile', figureFileName1, 'isEdit2')"
												>确定</el-button
											>
										</div>
									</div>
								</div>
							</div>
							<div class="goods-file">
								<new-upload
									class="mr15"
									ref="spftUpload"
									:aid="formObj.id"
									width="190"
									listType="picture-card"
									:lazyTime="lazyTime"
									:tableName="'tem_good_list'"
									assortment="good_pic_add_two"
									:acceptType="goodsAccept"
									:maxNum="1"
									:title="'商品附图'"
									@getFileSuccess="getFileSuccess($event, 'figureFile2')"
									@saveSuccess="saveSuccess"
									@onDelFile="onDelFile"
									:isDisabled="isDiabled"
								></new-upload>
								<div class="mt10" v-if="figureFile2.length != 0">
									<div v-if="!isEdit3" style="text-align: center">
										<span class="ellipsis">{{ figureFile2[0].fileName }}</span>
										<svg-icon
											v-if="!isDiabled"
											icon-class="form-edit"
											style="color:#409EFF;vertical-align: 2px "
											class="ml5"
											@click="openEdit('figureFileName2', figureFile2[0].fileName, 'isEdit3')"
										></svg-icon>
									</div>
									<div v-else>
										<el-input v-model="figureFileName2" size="small" :maxlength="20"></el-input>
										<div class="flex">
											<el-button size="mini" class="mt10" @click="clearEdit('figureFileName2', 'isEdit3')">取消</el-button>
											<el-button
												size="mini"
												type="primary"
												class="mt10"
												@click="saveFileName('figureFile2', figureFileName2, 'isEdit3')"
												>确定</el-button
											>
										</div>
									</div>
								</div>
							</div>
							<div class="goods-file">
								<new-upload
									class="mr15"
									ref="yyzzUpload"
									:aid="formObj.id"
									width="190"
									listType="picture-card"
									:lazyTime="lazyTime"
									:tableName="'tem_good_list'"
									assortment="good_pic_add_three"
									:acceptType="goodsAccept"
									:maxNum="1"
									:title="'商品附图'"
									@getFileSuccess="getFileSuccess($event, 'figureFile3')"
									@saveSuccess="saveSuccess"
									@onDelFile="onDelFile"
									:isDisabled="isDiabled"
								></new-upload>
								<div class="mt10" v-if="figureFile3.length != 0">
									<div v-if="!isEdit4" style="text-align: center">
										<span class="ellipsis">{{ figureFile3[0].fileName }}</span>
										<svg-icon
											v-if="!isDiabled"
											icon-class="form-edit"
											style="color:#409EFF;vertical-align: 2px "
											class="ml5"
											@click="openEdit('figureFileName3', figureFile3[0].fileName, 'isEdit4')"
										></svg-icon>
									</div>
									<div v-else>
										<el-input v-model="figureFileName3" size="small" :maxlength="20"></el-input>
										<div class="flex">
											<el-button size="mini" class="mt10" @click="clearEdit('figureFileName3', 'isEdit4')">取消</el-button>
											<el-button
												size="mini"
												type="primary"
												class="mt10"
												@click="saveFileName('figureFile3', figureFileName3, 'isEdit4')"
												>确定</el-button
											>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Panel>
					<Panel :expand="true" :title="formObj.isJoint && formObj.isJoint == '1' ? '#5 商品状态信息' : '#4 商品交付信息'">
						<el-form-item label="商品状态" prop="status" :rules="requiredRule">
							<el-select v-model="formObj.status" size="small">
								<el-option v-for="item in proStatus" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
							</el-select>
						</el-form-item>
					</Panel>
				</el-form>
			</div>

			<!-- footer 组件 -->
			<div slot="footer" class="pdb10 pdt10 text-center">
				<el-button size="small" class="btn" :loading="dialogObj.btnLoading" @click="handleClosed()">取 消</el-button>
				<el-button
					type="primary"
					size="small"
					class="btn btn-blue"
					:loading="dialogObj.btnLoading"
					@click="doSubmit"
					v-if="dialogObj.type != 'view'"
					>保 存</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>
<script>
// components
import Panel from "components/panel/Panel";
import { mapState } from "vuex";
import XEUtils from "xe-utils";

import * as Api from "@/api/modules/commodity-management";

import CaRightsVue from "./CaRights.vue";
import platformRights from "./platformRights.vue";
import newUpload from "./w-upload/newUpload.vue";

export default {
	components: { Panel, newUpload, CaRightsVue, platformRights },
	data() {
		return {
			isDiabled: false, //禁止编辑
			dialogObj: {
				btnLoading: false,
				visible: false,
				width: '800px',
				title: '', //标题
				type: '' //类型
			},
			lazyTime: 1000, //图片回显延迟
			goodsAccept: ['png', 'jpeg', 'jpg', 'bmp'],
			acceptArr: ['pdf', 'jpeg', 'jpg', 'docx', 'xlsx'],
			templateName: '移动CA认证服务费', //模板名称
			formObj: {
				id: '',
				newFlag: '', //0 添加 1 修改
				sname: '', //商品名称
				proValue: '', //商品级码表
				isJoint: '', //是否组合商品
				proId: '', //商品识别码
				proAttr: '', //商品属性
				proType: '', //商品类型
				proSup: '', //商品大类
				proSub: '', //商品子类
				applySub: '', //归属主体
				proIntro: '', //商品简介
				feeType: '', //收费方式
				cycleType: '', //收费规则 0：按年定价/固定单价；1：按月定价/阶梯单价；2：按天定价
				cycleValue: '', //可订购周期码表
				cycleDigit: '', //可订购周期数值
				fixPrice: '', //固定单价
				isDevide: '', //是否分账
				devideType: '', //分账方式
				platRatio: '', //平台分账比例/金额
				merRatio: '', //商家分账比例/金额
				subTenant: '', //分账主体
				collectTenant: '', //收款公司
				collectAccount: '', //收款账户名
				collectNo: '', //收款账号
				collectBank: '', //收款开户行
				collectLink: '', //收款联系人
				taxNo: '', //税号
				status: '', //商品状态
				//阶梯价
				stairPriceList: [
					{
						useTime: '',
						usePrice: ''
					},
					{
						useTime: '',
						usePrice: ''
					}
				],
				usePrice: '',
				goods: [],
				giveGoodList: []
			},
			picMainFile: [], //主图
			PicMainFileName: '',
			figureFile: [], // 附图一
			figureFileName1: '',
			figureFile2: [], // 附图二
			figureFileName2: '',
			figureFile3: [], // 附图三
			figureFileName3: '',
			isEdit1: false,
			isEdit2: false,
			isEdit3: false,
			isEdit4: false,
			proAttrOptions: [], //商品属性options
			proTypeOptions: [], //商品类型options
			proSupOptions: [], //商品大类options
			proSubOptions: [], //商品子类options
			options: [], //可订购周期options
			goodOptions: [],
			requiredRule: [{ required: true, message: '', trigger: ['change', 'blur'] }],
			tableData: []
		}
	},
	created() {},
	methods: {
		//打开弹窗
		openDialog(type, obj) {
			this.getList()
			this.dialogObj.type = type
			this.dialogObj.title = type == 'add' ? '新增商品' : type == 'edit' ? '编辑商品' : '查看商品'
			this.dialogObj.visible = true
			this.isDiabled = type == 'view' ? true : false
			this.getGoodCatCascade()
			this.getDetail(obj)
			this.formObj.id = obj.giveId
		},
		//获取商品属性
		getGoodCatCascade(vale, type) {
			Api.getGoodCatCascade({})
				.then((res) => {
					console.log(res)
					this.proAttrOptions = res.data
				})
				.catch((err) => {})
		},

		//详情
		getDetail(obj) {
			Api.getGoodDetail({ id: obj.giveId })
				.then((res) => {
					Object.keys(this.formObj).forEach((key) => {
						this.formObj[key] = ''
					})
					let datas = res.data
					//商品属性
					this.changeSelect('1', datas.proAttr)
					//商品类型
					this.changeSelect('2', datas.proType)
					//商品大类
					this.changeSelect('3', datas.proSup)
					//可订购周期
					this.changeSelect('5', datas.cycleType)

					Object.keys(this.formObj).forEach((key) => {
						this.formObj[key] = datas[key]
					})

					let ids = datas.giveGoodList.map((item) => item.giveId)
					this.formObj.goods = ids
					this.tableData = datas.giveGoodList
					this.formObj.stairPriceList = datas.stairPriceList || this.stairPriceList

					//阶梯价处理
					let stairPriceList = datas.stairPriceList || []
					let _item = stairPriceList.filter((x) => x.useTime != '' && x.usePrice != '')
					if (this.formObj.feeType == '1' && this.formObj.cycleType == '1') {
						if (_item && _item.length == 2) {
							this.formObj.usePrice = '阶梯价'
						} else {
							this.formObj.usePrice = ''
						}
					}
				})
				.catch((err) => {})
		},

		//获取赠品商品
		getList() {
			Api.getGiveGoodList({})
				.then((res) => {
					this.goodOptions = res.data
				})
				.catch((err) => {
					this.goodOptions = []
				})
		},

		//select操作处理
		changeSelect(type, value) {
			console.log(type)
			console.log('395878978989')
			switch (type) {
				//商品属性
				case '1':
					this.formObj.proType = '' //商品类型
					this.formObj.proSup = '' //商品大类
					this.formObj.proSub = '' //商品子类
					this.proTypeOptions = [] //商品类型options
					this.proSupOptions = [] //商品大类options
					this.proSubOptions = [] //商品大类options

					//获取商品类型options
					if (value != '') {
						let _item = this.proAttrOptions.find((x) => x.value == value)
						this.proTypeOptions = _item.children
					}
					break
				//商品类型
				case '2':
					this.formObj.proSup = '' //商品大类
					this.formObj.proSub = '' //商品子类
					this.proSupOptions = [] //商品大类options
					this.proSubOptions = [] //商品子类options

					//获取商品大类options
					if (value != '') {
						let _item = this.proTypeOptions.find((x) => x.value == value)
						this.proSupOptions = _item.children
					}
					break
				//商品大类
				case '3':
					this.formObj.proSub = '' //商品子类
					this.proSubOptions = [] //商品子类options

					//获取商品子类options
					if (value != '') {
						let _item = this.proSupOptions.find((x) => x.value == value)
						this.proSubOptions = _item.children
					}
					break
				//收费方式
				case '4':
					this.formObj.cycleType = '' //收费规则
					this.formObj.cycleValue = '' //可订购周期
					this.formObj.fixPrice = '' //商品价格
					//阶梯价
					;(this.formObj.stairPriceList = [
						{
							useTime: '',
							usePrice: ''
						},
						{
							useTime: '',
							usePrice: ''
						}
					]),
						(this.usePrice = '')
					break
				//收费规则（按周期）
				case '5':
					//可订购周期options
					this.options =
						value == 0 ? this.commodityDict.dgzqn : value == 1 ? this.commodityDict.dgzqy : value == 2 ? this.commodityDict.dgzqt : []

				//收费规则（按次）
				case '6':
					this.formObj.cycleValue = '' //可订购周期
					this.formObj.fixPrice = '' //商品价格
					;(this.formObj.stairPriceList = [
						{
							useTime: '',
							usePrice: ''
						},
						{
							useTime: '',
							usePrice: ''
						}
					]),
						(this.usePrice = '')
					break
				//可收购周期cycleDigi取值处理
				case '7':
					let item = this.options.find((x) => x.value == value)
					if (item) {
						let name = item.sname
						let dynamicRegex = new RegExp(`[${'年月日天'}]`, 'g')
						//let dynamicRegex = this.createDynamicRegex('年月日天')
						let parts = name.split(dynamicRegex)
						this.formObj.cycleDigit = parts[0]
					}

					break
			}
		},
		//赠送商品处理
		changeGoods(value) {
			let arr = []
			let newArr = [].concat(this.goodOptions)
			if (value && value.length != 0) {
				newArr.map((x) => {
					value.map((y) => {
						if (x.id == y) {
							let obj = {
								giveName: x.sname,
								giveId: x.id,
								giveNum: ''
							}
							arr.push(obj)
						}
					})
				})
			}

			this.formObj.giveGoodList = arr
		},
		//字符串分割
		createDynamicRegex(chars) {
			return new RegExp(`[${chars}]`, 'g')
		},
		//商品权益信息输入处理
		moneyCheck(value, bindForm, bindKey, form, index) {
			value = value.replace(/^0|[^0-9]/g, '')
			if (bindKey == 'giveGoodList') {
				this.$set(this[bindForm].giveGoodList[index], form, value)
			} else {
				this.$set(this[bindForm], bindKey, value)
			}

			return value
		},
		// 价格输入处理
		priceMoneyCheck(value, bindForm, bindKey, form, index) {
			value = value
				.replace(/^0{1,}\d/g, '')
				.replace(/^\D*(\d{0,9}(?:\.\d{0,2})?).*$/g, '$1')
				.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')

			//阶梯价处理
			if (bindKey == 'stairPriceList') {
				this.$set(this[bindForm].stairPriceList[index], form, value)
				let _item = this.formObj.stairPriceList.filter((x) => x.useTime != '' && x.usePrice != '')
				if (_item && _item.length == 2) {
					this.formObj.usePrice = '阶梯价'
				} else {
					this.formObj.usePrice = ''
					return
				}

				return
			}

			this.$set(this[bindForm], bindKey, value)
			let number = this.formObj.platRatio * 1 + this.formObj.merRatio * 1
			if (this.formObj.devideType == '1') {
				if ((bindKey == 'platRatio' || bindKey == 'merRatio') && number > 100) {
					this.$message.warning('平台分账比例+商家分账比例不能大于100')
					return ''
				}
			}

			return value
		},
		//=============平台技术服务权益权益有效期计算===========
		getValidDay() {
			let validDay = ''
			if (this.formObj.cycleType == 0) {
				//年计算
				validDay = this.formObj.cycleDigit * 365 + 60
				return validDay
			} else if (this.formObj.cycleType == 1) {
				//月计算（按照自然月天数计算）
				//获取选择月份对应的天数
				let day = this.getDaysInMonth(this.formObj.cycleDigit)
				validDay = day * 1 + 60
				return validDay
			} else if (this.formObj.cycleType == 2) {
				//天计算
				validDay = this.formObj.cycleDigit * 1 + 60
				return validDay
			}
		},
		//获取月份是对应的天数
		getDaysInMonth(month) {
			//获取当前年份
			const year = new Date().getFullYear()
			// 检查月份是否在1到12之间
			if (month < 1 || month > 12) return null
			// 每月的固定天数
			const daysInMonth = [31, year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

			// 返回指定月份的天数
			return daysInMonth[month - 1]
		},
		//===========================end=====================
		//===============================商品图片处理=====================
		//商品图片上传完成处理
		saveSuccess(params) {
			Api.saveFile(params)
				.then(() => {})
				.catch((err) => {})
		},
		//删除附件操作
		onDelFile(file) {
			Api.deleteFile({ id: file.id })
				.then((res) => {})
				.catch((err) => {})
		},
		//获取图片后处理
		getFileSuccess(file, form) {
			if (file && file.length > 0) {
				let arr = file[0].fileName.split('.')
				file[0].gs = arr[1]
				file[0].fileName = arr[0]
				this[form] = file
			} else {
				this[form] = []
			}

			//this[form].push(res.data)
		},
		//打开图片名称编辑
		openEdit(form, name, edit) {
			this[edit] = true
			this[form] = name
		},
		//保存图片名称编辑
		saveFileName(form, name, edit) {
			if (this[name] == '') {
				this.$message.warning('请输入要变更的图片名称！')
				return
			}
			this[edit] = false
			this[form][0].fileName = name
		},
		//取消编辑
		clearEdit(form, edit) {
			this[form] = ''
			this[edit] = false
		},
		//附件名称处理
		getGoodsFile() {
			let arr = [...this.picMainFile, ...this.figureFile, ...this.figureFile2, ...this.figureFile3]
			let newData = JSON.stringify(arr)
			let fileList = JSON.parse(newData)
			fileList.map((item) => {
				let name = item.fileName + '.' + item.gs
				item.fileName = name
			})
			return fileList
		},
		//===========================================end
		//提交
		doSubmit() {
			let fileList = this.$refs.good_pic_main.filesList
			let _item = fileList.find((x) => x.id && x.id != '')
			this.$refs.formObjRfe.validate((valid) => {
				if (valid) {
					if (!_item) {
						this.$message.warning('请上传商品主图')
						return
					}
					this.doSave()
				} else {
					this.$message.warning('有必填项未填，请填写')

					return false
				}
			})
		},
		//保存
		doSave() {
			let params = XEUtils.clone(this.formObj, true)

			//商品图片
			params.imgList = this.getGoodsFile()

			console.log(params)
			//return
			delete params.usePrice
			this.dialogObj.btnLoading = true
			Api.insertOrUpdateGood(params)
				.then((res) => {
					this.dialogObj.btnLoading = false
					if (res.operationCode == 1) {
						console.log(res)
						this.$message.success('提交成功！')
						this.handleClosed()
					} else {
						this.$message.error(res.msg)
					}
				})
				.catch((err) => {
					this.dialogObj.btnLoading = false
				})
		},
		//关闭弹窗
		handleClosed() {
			this.dialogObj = {
				btnLoading: false,
				visible: false,
				width: '800px',
				title: '',
				type: ''
			}
			Object.keys(this.formObj).forEach((key) => {
				this.formObj[key] = ''
			})

			this.$emit('updated')
		}
	},
	computed: {
		...mapState('dict', {
			commodityDict: (state) => state.commodityDict //商品字典
		}),
		//商品状态
		proStatus() {
			let arr = [
				{
					value: 0,
					sname: '下架'
				},
				{
					value: 1,
					sname: '上架'
				},
				{
					value: 2,
					sname: '已售罄'
				},
				{
					value: 3,
					sname: '暂停销售'
				}
			]
			return arr
		},
		//归属主题
		gszt() {
			let arr = [
				{
					sname: '能工社',
					value: '1015003'
				},
				{
					sname: '安招采',
					value: '1015001'
				}
			]
			return arr
		},
		stairPriceList() {
			return [
				{
					useTime: '',
					usePrice: ''
				},
				{
					useTime: '',
					usePrice: ''
				}
			]
		}
	}
}
</script>
<style lang="less" scoped>
.product-list-dialog {
	/deep/.el-collapse {
		border-top: none;
	}
	/deep/.el-collapse-item__header {
		font-size: 14px !important;
		font-weight: 600 !important;
		padding-left: 30px !important;
		background-color: #eff6fe !important;
		margin-top: 5px;
		height: 36px;
		line-height: 36px;
	}
	/deep/.el-collapse-item__wrap {
		border-bottom: none;
	}

	.w100 {
		width: 160px;
	}
	.w200 {
		width: 330px;
	}
	.flex {
		span {
			margin-right: 10px;
		}
	}
	.label-class {
		/deep/.el-form-item__label {
			line-height: unset;
		}
	}
	.file-container {
		width: 100% !important;
		height: 100% !important;
	}
	/deep/.el-upload--picture-card {
		.el-button {
			padding: 60px 0px;
		}
	}
	.justify-content {
		justify-content: space-between;
		height: 180px;
	}
	.ellipsis {
		white-space: nowrap; /* 防止文本换行 */
		overflow: hidden; /* 隐藏溢出的内容 */
		text-overflow: ellipsis; /* 显示省略符号来代表被修剪的文本 */
		display: inline-block;
		max-width: 80%;
	}
	.h230 {
		height: 230px;
	}
	.goods-file {
		width: 160px;
		height: 160px;
	}
	.lh36 {
		line-height: 36px;
	}
	/*/deep/.el-carousel__item
	{
		overflow: visible;
	}
	/deep/.el-carousel--horizontal {overflow-x: visible;}*/
	/deep/.append-btn .el-input-group__append {
		background: #256ccb;
		color: #fff;
	}
	.tips-color {
		color: red;
	}
	.goods-list {
		width: 100%;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
		.list-title {
			padding-left: 10px;
		}
		/deep/.el-input-group {
			width: 200px;
		}
		/deep/.el-input__inner,
		/deep/.el-input-group__append {
			border-radius: 0;
		}
	}
	.goods-box {
		width: 100%;
		overflow: hidden;
		display: flex;
		.lable {
			width: 110px;
			text-align: right;
			padding-right: 12px;
		}
		.table {
			width: 625px;
		}
	}
}
</style>
<style>
.primary-dialog .el-dialog__body {
	padding: 30px 30px;
	max-height: 750px;
}
.upload-form .list-upload .upload-demo {
	display: block !important;
}
.upload-form .list-upload .file-tip {
	line-height: 30px;
}
.upload-form .el-upload--text,
.upload-form .el-upload__tip {
	float: left;
	margin-right: 20px;
}
.upload-form .el-upload-list {
	clear: both;
}
</style>
<style>
.upload-form .list-upload .upload-demo {
	display: block !important;
}
.upload-form .list-upload .file-tip {
	line-height: 30px;
}
.upload-form .el-upload--text,
.upload-form .el-upload__tip {
	float: left;
	margin-right: 20px;
}
.upload-form .el-upload-list {
	clear: both;
}
</style>
